import React, { useMemo } from 'react'
import { Loading } from '/src/components/loading'
import PaymentPaneForm from './PaymentPaneForm'
import PaymentPaneTradeForm from './PaymentPaneTradeForm'

import './payment_pane.scss'

export const PaymentPane = ({ cart, user }) => {
  const tradeUser = useMemo(() => user && user.trade, [user])

  if (!user || !cart) {
    return (
      <div className="payment-pane-container">
        <Loading />
      </div>
    )
  }

  if (tradeUser) {
    return (
      <div className="payment-pane-container">
        <PaymentPaneTradeForm cart={cart} user={user} />
      </div>
    )
  }

  return (
    <div className="payment-pane-container">
      <PaymentPaneForm cart={cart} user={user} />
    </div>
  )
}

export default PaymentPane
